























import { Component, Prop, Vue, Watch, Emit } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'
import BackButton from '@/shared/BackButton.component.vue'
import { PROCESSING_NAME } from '@/features/processing/processing.router'
import { projectListLocalisationKeys } from '@/features/projectList/projectList.localisation'
import { matchFieldsLocalisationKeys } from '@/features/matchFields/matchFields.localisation'

import {
  GET_MATCHER,
  GET_ERRORS
} from '@/system/store/getter-types'
import { TRANSFORM_DATA_ACTION } from '@/system/store/action-types'
import { IProjectStore, ISelectedProjects } from '@/features/projectList/store'
import { IIssue } from '@/features/matchFields/store'

@Component({
  components: {
    BackButton
  }
})
export default class MatchFieldsNavigationBtn extends Vue {
  private translations = matchFieldsLocalisationKeys
  private translationsProjectLsit = projectListLocalisationKeys
  private nextPage: string = PROCESSING_NAME

  @Getter(GET_MATCHER)
  matcher!: any
  @Getter(GET_ERRORS)
  errors!: IIssue[]

  get getDisable () {
    return Boolean(!this.matcher.rooms.length) || Boolean(this.errors.length)
  }

  get getMessage () {
    if (this.errors.length) return this.$t(this.translations.RESOLVE_ERRORS)
    return this.$t(this.translations.PLEASE_MATCH_DATA)
  }

  @Emit('clickedNext')
  handleSendMatcher (): string {
    return this.nextPage
  }
}
